<template lang="html">

  <section class="registro">

    <div class="header-wrapper -fake" :style="style.colorDarkBlack">

      <section class="header row-between">

        <span class="fake-bg" :style="`background:url(${background}) center/cover no-repeat`"></span>

        <div class="contenedor-logo row-start">

          <router-link class="logo row-start" to="/">
            <img :src="logoselected" alt="Logo" :size="logosize">
          </router-link>

        </div>

      </section>



    </div>

    <encabezado :data="'solicitar_cuenta'" :inicioPersonalizado="'/login/empresas'"></encabezado>

    <form class="form row-start container">

      <template v-if="paso == 1">

        <router-link class="back" to="/login/empresas">
          {{ $t('volver') }} </router-link>

        <div class="text-container">

          <p><strong>{{ $t('registro.encabezado') }}</strong></p>

        </div>

        <div class="row-start form">

          <h3 class="epigrafe">{{ $t('registro.datos_usuario') }}</h3>

          <div class="contenedor-input type-text one-slot">
            <label for="">{{ $t('registro.nombre') }}*</label>
            <input type="text" v-validate="'required|min:3'" name="nombre" v-model="data.contacto.nombre"
              autocomplete="none">
            <span class='error' v-if="clicked">{{ errors.first('nombre') }}</span>
          </div>

          <div class="contenedor-input type-text one-slot">
            <label for="">{{ $t('registro.apellidos') }}*</label>
            <input type="text" v-validate="'required|min:3'" name="apellidos" v-model="data.contacto.apellidos"
              autocomplete="none">
            <span class='error' v-if="clicked">{{ errors.first('apellidos') }}</span>
          </div>

          <div class="contenedor-input type-text one-slot"
            v-if="!!brand.registroEmpresas.dni && brand.registroEmpresas.dni.visible">
            <label for="">{{ $t('registro.DNI') }}*</label>
            <input type="text" v-model="data.contacto.nif" v-validate="'required|min:9'" name="dni" autocomplete="none"
              :class="[{ 'has-error': errors.has('dni') }]">
            <span class='error' v-if="clicked">{{ errors.first('dni') }}</span>
          </div>


          <div class="contenedor-input type-text one-slot">
            <label for="">{{ $t('registro.CIF') }}*</label>
            <input type="text" @blur="checkCIF" v-model="data.empresa.cif" v-validate="'required|min:3'"
              name="cifempresa" :class="[{ 'has-error': errors.has('cifempresa') }]" autocomplete="none">
            <span class='error' v-if="clicked">{{ errors.first('cifempresa') }}</span>
          </div>

          <div class="contenedor-input type-text one-slot -wo-margin">
            <label for="">{{ $t('registro.puesto') }}*</label>
            <input type="text" v-validate="'required|min:3'" name="puesto" v-model="data.contacto.puesto"
              autocomplete="none">
            <span class='error' v-if="clicked">{{ errors.first('puesto') }}</span>
          </div>

          <div class="contenedor-input type-text one-slot">
            <label for="">{{ $t('registro.departamento') }}</label>
            <input type="text" name="departamento" v-model="data.contacto.departamento" v-validate="'min:3'"
              autocomplete="none">
          </div>



          <div class="contenedor-input type-text one-slot">
            <label for="">{{ $t('registro.telefono_1') }}*</label>
            <input type="text" v-validate="'required|max:14|min:9|integer'" name="telefono"
              v-model="data.contacto.telefono1" autocomplete="none">
            <span class='error' v-if="clicked">{{ errors.first('telefono') }}</span>
          </div>

          <div class="contenedor-input type-text one-slot -wo-margin">
            <label for="">{{ $t('registro.telefono_2') }}</label>
            <input type="text" name="telefono2" v-model="data.contacto.telefono2" v-validate="'max:14|min:9|integer'"
              autocomplete="none">
            <span class='error' v-if="clicked">{{ errors.first('telefono2') }}</span>
          </div>

          <div class="contenedor-input type-text one-slot -wo-margin">
            <label for="">{{ $t('registro.email') }}*</label>
            <input type="text" v-validate="'required|email'" name="email" v-model="data.contacto.email"
              autocomplete="none">
            <span class='error' v-if="clicked">{{ errors.first('email') }}</span>
          </div>



          <div class="contenedor-input type-text one-slot"
            v-if="!!brand.registroEmpresas.sede && brand.registroEmpresas.sede.visible">
            <label for="">{{ $t('registro.sede') }}{{ (brand.registroEmpresas.sede.required) ? '*' : '' }}</label>
            <select name="sede" v-model="data.contacto.idSede" autocomplete="none">
              <option value="">-{{ $t('registro.elige') }}-</option>
              <option v-if="!!dominios" v-for="(el, key) in dominios.sedes" :value="Number(key)">{{ el }}</option>
            </select>
            <span class='error' v-if="clicked">{{ errors.first('sede') }}</span>
          </div>

          <div
            :class="['contenedor-input row-start type-text', (dominiosArray.idiomasDeConfiguracion.length <= 2) ? 'one-slot' : 'three-slot']"
            v-if="brand.requestidiomaComunicacionContacto && !!dominiosArray.idiomasDeConfiguracion">
            <label for="">{{ $t('registro.idioma') }}*</label>
            <template v-if="!!dominiosArray">
              <div class="radio-container" v-for="(tipo, key) in dominiosArray.idiomasDeConfiguracion">
                <input type="radio" :value="tipo[0]" :id="'tipo-idIdiomaPreferido-' + tipo[0]"
                  v-model="data.contacto.idIdiomaPreferido" name="idIdiomaPreferido" autocomplete="none">
                <label :for="'tipo-idIdiomaPreferido-' + tipo[0]">{{ tipo[1] }}</label>
              </div>
            </template>
            <span class='error' v-if="clicked">{{ errors.first('privada') }}</span>
          </div>

          <div
            :class="['contenedor-input row-start type-text', (dominiosArray.tiposContacoEmpresa.length <= 2) ? 'one-slot' : 'three-slot']"
            v-if="brand.requestTipoContacto">
            <label for="">{{ $t('registro.tipo_contacto') }}*</label>
            <template v-if="!!dominiosArray">
              <div class="radio-container" v-for="(tipo, key) in dominiosArray.tiposContacoEmpresa">
                <input type="checkbox" :value="tipo[0]" :id="'tipo-contacto-' + tipo[0]"
                  v-model="data.contacto.tipocontacto" name="tipocontacto" autocomplete="none">
                <label :for="'tipo-contacto-' + tipo[0]">{{ tipo[1] }}</label>
              </div>
            </template>
            <span class='error' v-if="clicked">{{ errors.first('privada') }}</span>
          </div>

          <div class="contenedor-input one-slot">
            <label for="">{{ $t('registro.contrasena') }}*</label>
            <input type="password" name="password" v-validate="'required|min:8'" autocomplete='nope'
              :class="[{ 'has-error': errors.has('password') }]" ref="password" v-model="data.contacto.password">
            <span class='error' v-if="clicked">{{ errors.first('password') }}</span>
          </div>

          <div class="contenedor-input one-slot -wo-margin">
            <label for="">{{ $t('registro.repetir_contrasena') }}*</label>
            <input type="password" name="password2" v-validate="'required|min:8|confirmed:password'" autocomplete='nope'
              :class="[{ 'has-error': errors.has('password2') }]" data-vv-as="password"
              v-model="data.contacto.password2">
            <span class='error' v-if="clicked">{{ errors.first('password2') }}</span>
          </div>

          <div class="contenedor-input three-slot">
            <input type="checkbox" name="politica" id="politica" v-validate="'required'">
            <label for="politica">{{ $t('registro.politica_1') }} <a :href="$t('registro.link_politica')"
                target="_blank">{{
                  $t('registro.politica_2') }}</a></label>
            <span class='error' v-if="clicked">{{ errors.first('politica') }}</span>
          </div>



          <template v-if="requestDireccionContacto || requestDireccionFullContacto">
            <h3 class="epigrafe">{{ $t('registro.direccion') }}</h3>
          </template>

          <template v-if="requestDireccionFullContacto">


            <div class="contenedor-input type-text one-slot">
              <label for="">{{ $t('registro.pais') }}*</label>
              <select name="paiscontacto" v-model="data.contacto.idPais" v-validate="'required'" autocomplete="off">
                <option value="">{{ $t('registro.selecciona_pais') }}</option>
                <option v-if="!!dominios" v-for="(el, key) in dominiosArray.paises" :value="Number(el[0])">{{ el[1] }}
                </option>
              </select>
              <span class='error' v-if="clicked">{{ errors.first('paiscontacto') }}</span>
            </div>

            <div class="contenedor-input type-text one-slot">
              <label for="">{{ $t('registro.provincia') }}*</label>
              <input type="text" name="provinciacontacto" v-model="data.contacto.provincia"
                v-if="data.contacto.idPais != 1" v-validate="'required|min:3'" autocomplete="off">
              <select autocomplete="none" name="provinciacontacto" v-model="data.contacto.provincia"
                v-validate="'required'" v-else>
                <option value="">{{ $t('registro.selecciona_provincia') }}</option>
                <option v-if="!!dominios" v-for="(el, key) in dominiosArray.provincias" :value="Number(el[0])">
                  {{ el[1] }}</option>
              </select>
              <span class='error' v-if="clicked">{{ errors.first('provinciacontacto') }}</span>
            </div>

            <div class="contenedor-input one-slot -empty" v-if="!requestDireccionContacto">
            </div>

          </template>


          <template v-if="requestDireccionContacto">

            <div class="contenedor-input one-slot">
              <label for="">{{ $t('registro.localidad') }}*</label>

              <select name="localidadcontacto" v-model="data.contacto.idLocalidad" v-validate="'required'"
                v-if="(data.empresa.pais == '1') && dominios.localidades.length != 0" autocomplete="none">
                <option value="">{{ $t('registro.selecciona_localidad') }}</option>
                <option v-if="!!dominios" v-for="(el, key) in localidadesfilter(data.contacto.provincia)"
                  :value="el.idLocalidad">
                  {{ el.descripcion }}
                </option>
              </select>

              <input autocomplete="off" type="text" name="localidadcontacto" v-model="data.contacto.localidad" v-else
                v-validate="'required'">



              <!-- <predictivo :options="localidadesfilter(data.contacto.provincia)" :placeholder="''" :multiple="false"
                    v-model="data.contacto.idLocalidad" name="localidadcontacto" :likeSelect="true" :alwaysFind="true"
                    v-if="data.contacto.idPais == '1'" :keyid="'idLocalidad'" ref="localidad" :searchIn="'descripcion'"
                    :preselected="data.contacto.localidad" v-validate="'required'"> 
                  </predictivo>-->

              <span class='error' v-if="clicked">{{ errors.first('localidadcontacto') }}</span>
            </div>


            <div class="contenedor-input type-text two-slot">
              <label for="">{{ $t('registro.direccion') }}*</label>
              <input type="text" name="direccion" v-model="data.contacto.direccion" v-validate="'required|min:3'"
                autocomplete="none">
              <span class='error' v-if="clicked">{{ errors.first('direccion') }}</span>
            </div>


            <div class="contenedor-input type-text one-slot">
              <label for="">{{ $t('registro.cp') }}*</label>
              <input type="number" name="cp" v-model="data.contacto.cp" v-validate="'required|numeric'"
                autocomplete="nope">
              <span class='error' v-if="clicked">{{ errors.first('cp') }}</span>
            </div>


          </template>


        </div>

      </template>

      <template v-if="paso == 2">

        <a class="back" @click="paso = 1">
          {{ $t('volver') }} </a>

        <div class="text-container">

          <p><strong>{{ $t('registro.titulo_2') }}</strong></p>

        </div>

        <div class="contenedor-subida-imagen row-start">

          <div class="contenedor-imagen" v-if="data.empresa.permiteUsarElLogo" @click="editimg = true">
            <span class="imagen" :style="'background:url(' + img + ') center/cover no-repeat'"></span>
            <span class="editcover row-center" v-if="!data.empresa.ficheroLogoB64ParaAltas">{{
              $t('registro.anadir_imagen') }}</span>
          </div>

          <div class="contenedor-autorizar-uso row-start">
            <toggle :show="true" :label="$t('registro.autorizar_logo')" :dataServer="data.empresa.permiteUsarElLogo"
              v-model="data.empresa.permiteUsarElLogo" :show_result="false"></toggle>
            <popup-info :texto="'uso_logo'" :side="'right'"></popup-info>
          </div>


        </div>

        <div class="form row-start">

          <div class="contenedor-input type-text one-slot">
            <label for="">{{ $t('registro.nombre_fiscal') }}*</label>
            <input type="text" v-validate="'required|min:3'" name="nombre_fiscal" v-model="data.empresa.nombreFiscal"
              autocomplete='nope'>
            <span class='error' v-if="clicked">{{ errors.first('nombre_fiscal') }}</span>
          </div>

          <div class="contenedor-input type-text one-slot">
            <label for="">{{ $t('registro.nombre_comercial') }}*</label>
            <input type="text" v-validate="'required|min:3'" name="nombre_comercial"
              v-model="data.empresa.nombreComercial" autocomplete='nope'>
            <span class='error' v-if="clicked">{{ errors.first('nombre_comercial') }}</span>
          </div>

          <div class="contenedor-input type-text one-slot">
            <label for="">{{ $t('registro.tipo_sociedad') }}*</label>
            <select name="tipoEmpresa" v-model="data.empresa.idTipoEmpresa" v-validate="'required|min_value:1'"
              autocomplete='nope'>
              <option value="">{{ $t('registro.selecciona_tipo_sociedad') }}</option>
              <option v-if="!!dominios" v-for="(el, key) in dominiosArray.tiposEmpresa" :value="Number(el[0])">
                {{ el[1] }}</option>
            </select>
            <span class='error' v-if="clicked">{{ errors.first('tipoEmpresa') }}</span>
          </div>


          <div class="contenedor-input -radios row-start type-text one-slot" v-if="requestTipoEmpresa">
            <label for="">{{ $t('registro.tipo_empresa') }}*</label>
            <div class="radio-container">
              <input type="radio" :value="true" id="privada" v-model="data.empresa.privada" name="privada"
                v-validate="'required'">
              <label for="privada">{{ $t('registro.privada') }}</label>
            </div>
            <div class="radio-container">
              <input type="radio" :value="false" id="publica" v-model="data.empresa.privada" name="privada"
                v-validate="'required'">
              <label for="publica">{{ $t('registro.publica') }}</label>
            </div>
            <span class='error' v-if="clicked">{{ errors.first('privada') }}</span>
          </div>

          <div class="contenedor-input -radios row-start type-text one-slot" v-if="brand.requestStartUp">
            <label for="">{{ $t('registro.startup') }}*</label>
            <div class="radio-container">
              <input type="radio" :value="true" id="startup-si" v-model="data.empresa.startup" name="startup"
                v-validate="'required'">
              <label for="startup-si">{{ $t('registro.si') }}</label>
            </div>
            <div class="radio-container">
              <input type="radio" :value="false" id="startup-no" v-model="data.empresa.startup" name="startup"
                v-validate="'required'">
              <label for="startup-no">{{ $t('registro.no') }}</label>
            </div>
            <span class='error' v-if="clicked">{{ errors.first('startup') }}</span>
          </div>


          <div class="contenedor-input type-text one-slot" v-if="!!!brand.requestPerfilSectorial">
            <label for="">{{ $t('registro.sector') }}*</label>
            <!-- <select name="sector" v-model="data.empresa.idSector" v-validate="'required'" autocomplete='nope'>
              <option value="">{{ $t('registro.selecciona_sector') }}</option>
              <option v-if="!!dominios" v-for="(el, key) in dominiosArray.sectoresActividad" :value="Number(el[0])">
                {{ el[1] }}</option>
            </select> -->
            <predictivo :options="sectores" :placeholder="''" :multiple="false" v-model="data.empresa.idSector"
              name="sectorEmpresa" :likeSelect="true" :alwaysFind="true" :keyid="'id'" ref="sectorEmpresa"
              :searchIn="'description'" :preselected="data.empresa.idSector"  v-validate="'required'"
              :class="[{ 'has-error': errors.has('sectorEmpresa') }]">
            </predictivo>
            <span class='error' v-if="clicked">{{ errors.first('sectorEmpresa') }}</span>
          </div>
          <div class="contenedor-input type-text one-slot"
            v-if="!!brand.registroEmpresas.otrosector && brand.registroEmpresas.otrosector.visible && data.empresa.idSector == 18">
            <label for="">{{ $t('registro.otro_sector') }}*</label>
            <input type="text" v-validate="'required|max:150|min:3'" name="otrosector" v-model="data.empresa.otroSector"
              autocomplete='nope'>
            <span class='error' v-if="clicked">{{ errors.first('otrosector') }}</span>
          </div>


          <div class="contenedor-input type-text one-slot -wo-margin"
            v-if="!!brand.registroEmpresas.numeroempleados && brand.registroEmpresas.numeroempleados.visible">
            <label for="">{{ $t('registro.numero_empleados') }}*</label>
            <select name="categoria-empresa" v-model="data.empresa.idNumeroEmpleados" v-validate="'required'">
              <option value="">{{ $t('registro.selecciona_empleados') }}</option>
              <option v-if="!!dominios" v-for="(el, key) in dominios.numeroDeEmpleados" :value="Number(key)">{{ el }}
              </option>
            </select>
            <span class='error' v-if="clicked">{{ errors.first('categoria-empresa') }}</span>
          </div>


          <div class="contenedor-input type-text one-slot">
            <label for="">{{ $t('registro.web') }}</label>
            <input type="text" name="web" v-model="data.empresa.web" autocomplete='nope'>
          </div>

          <div class="contenedor-input type-text one-slot -wo-margin" v-if="!!brand.registroEmpresas.otrosector">
            <label for="">{{ $t('login.email') }}*</label>
            <input type="text" v-validate="'required|email'" name="email" v-model="data.empresa.email"
              autocomplete='nope'>
            <span class='error' v-if="clicked">{{ errors.first('email') }}</span>
          </div>

          <div class="contenedor-input type-text one-slot -wo-margin">
            <label for="">{{ $t('registro.telefono_1') }}*</label>
            <input type="text" v-validate="'required|max:14|min:9|integer'" name="telefono_empresa"
              v-model="data.empresa.telefono">
            <span class='error' v-if="clicked">{{ errors.first('telefono_empresa') }}</span>
          </div>


          <div class="contenedor-input type-text full-slot"
            v-if="!!brand.registroEmpresas.iban && brand.registroEmpresas.iban.visible">
            <label for="">{{ $t('registro.iban') }}</label>
            <p class="text-info" v-html="$t('registro.iban_info')"></p>
            <input type="text" name="iban" v-model="data.empresa.iban" v-validate="'checkiban|max:24'"
              autocomplete='nope'>
            <span class='error' v-if="clicked">{{ errors.first('iban') }}</span>
          </div>




          <div
            :class="['contenedor-input row-start type-text', (dominiosArray.idiomasDeConfiguracion.length <= 2) ? 'one-slot' : 'three-slot']"
            v-if="brand.requestidiomaComunicacionContacto && !!dominiosArray.idiomasDeConfiguracion">
            <label for="">{{ $t('registro.idioma') }}*</label>
            <template v-if="!!dominiosArray">
              <div class="radio-container" v-for="(tipo, key) in dominiosArray.idiomasDeConfiguracion">
                <input type="radio" :value="tipo[0]" :id="'tipo-idIdiomaPreferido-' + tipo[0]"
                  v-model="data.empresa.idIdiomaPreferido" name="idIdiomaPreferido">
                <label :for="'tipo-idIdiomaPreferido-' + tipo[0]">{{ tipo[1] }}</label>
              </div>
            </template>
            <span class='error' v-if="clicked">{{ errors.first('privada') }}</span>
          </div>


          <div class="contenedor-input type-textarea">
            <label for="">{{ $t('registro.descripcion_empresa') }}*</label>
            <span v-if="!!data.empresa.descripcion" v-show="data.empresa.descripcion.length > 500" class="maxlength">{{
              data.empresa.descripcion.length }} / 600</span>
            <textarea v-model="data.empresa.descripcion" maxlength="600" v-validate="'required'" name="descripcion"
              autocomplete='nope'></textarea>
            <span class='error' v-if="clicked">{{ errors.first('descripcion') }}</span>
          </div>

          <h3 class="epigrafe">{{ $t('oferta.direccion') }} Fiscal Empresa</h3>

          <div class="contenedor-input type-text one-slot -wo-margin">
            <label for="">{{ $t('oferta.pais') }}*</label>
            <select name="pais" v-model="data.empresa.pais" v-validate="'required'" autocomplete='nope'>
              <option value="">{{ $t('registro.selecciona_pais') }}</option>
              <option v-if="!!dominios" v-for="(el, key) in dominiosArray.paises" :value="Number(el[0])">{{ el[1] }}
              </option>
            </select>
            <span class='error' v-if="clicked">{{ errors.first('pais') }}</span>
          </div>

          <div class="contenedor-input type-text one-slot -wo-margin">
            <label for="">{{ $t('oferta.provincia') }}*</label>
            <input type="text" name="provincia" v-model="data.empresa.provincia" v-if="data.empresa.pais != 1"
              v-validate="'required|min:3'" autocomplete='nope'>
            <select name="provincia" v-model="data.empresa.provincia" v-validate="'required'" autocomplete='nope'
              v-else>
              <option value="">{{ $t('registro.selecciona_provincia') }}</option>
              <option v-if="!!dominios" v-for="(el, key) in dominiosArray.provincias" :value="Number(el[0])">
                {{ el[1] }}</option>
            </select>
            <span class='error' v-if="clicked">{{ errors.first('provincia') }}</span>
          </div>


          <div class="contenedor-input one-slot">
            <label for="">Localidad*</label>

            <select name="localidadempresa" v-model="data.empresa.idLocalidad" v-validate="'required'"
              v-if="(data.empresa.pais == '1') && dominios.localidades.length != 0" autocomplete='nope'>
              <option value="">{{ $t('registro.selecciona_localidad') }}</option>
              <option v-if="!!dominios" v-for="(el, key) in localidadesfilter(data.contacto.provincia)"
                :value="el.idLocalidad">
                {{ el.descripcion }}
              </option>
            </select>

            <input type="text" autocomplete='nope' name="localidadempresa" v-model="data.empresa.localidad" v-else
              v-validate="(!!data.empresa.pais) ? 'required|min:3' : ''">
            <span class='error' v-if="clicked">{{ errors.first('localidadempresa') }}</span>
          </div>


          <div class="contenedor-input type-text two-slot">
            <label for="">{{ $t('oferta.direccion') }}*</label>
            <input type="text" v-validate="'required|min:3'" name="direccion" v-model="data.empresa.direccion"
              autocomplete='nope'>
            <span class='error' v-if="clicked">{{ errors.first('direccion') }}</span>
          </div>



          <div class="contenedor-input type-text one-slot">
            <label for="">{{ $t('registro.cp') }}*</label>
            <input type="number" v-validate="'required|numeric'" v-model="data.empresa.cp" autocomplete='nope'>
            <span class='error' v-if="clicked">{{ errors.first('codigoPostal') }}</span>
          </div>

        </div>

        <template v-if="!!!brand.hideRequestFirmanteRegistro">

          <div class="text-container -firmante">
            <p><strong>{{ $t('registro.firmante.titulo') }}</strong></p>
          </div>

          <div class="row-between">

            <div class="contenedor-input type-text one-slot">
              <label for="Nombre firmante">{{ $t('registro.firmante.nombre') }}</label>
              <input type="text" name="nombre_firmante" v-model="data.empresa.firmante1.nombre">
            </div>

            <div class="contenedor-input type-text one-slot">
              <label for="apellidos firmante">{{ $t('registro.firmante.apellidos') }}</label>
              <input type="text" name="apellidos_firmante" v-model="data.empresa.firmante1.apellidos">
            </div>

            <div class="contenedor-input type-text one-slot">
              <label for="email firmante">{{ $t('registro.firmante.email') }}</label>
              <input type="text" name="email_firmante" v-validate="'email'" v-model="data.empresa.firmante1.email">
              <span class='error' v-if="clicked">{{ errors.first('email_firmante') }}</span>
            </div>

            <div class="contenedor-input type-text one-slot">
              <label for="DNI firmante">{{ $t('registro.firmante.dni') }}</label>
              <input type="text" name="dni_firmante" v-model="data.empresa.firmante1.dni">
            </div>

            <div class="contenedor-input type-text one-slot">
              <label for="Cargo firmante">{{ $t('registro.firmante.cargo') }}</label>
              <input type="text" name="cargo_firmante" v-model="data.empresa.firmante1.cargo">
            </div>

            <div class="contenedor-input type-text one-slot"></div>

          </div>

        </template>

        <template v-if="brand.requestDireccionFacturacion">

          <h3 class="epigrafe">{{ $t('registro.envio_facturas.titulo') }}</h3>


          <div class="contenedor-direccion-facturacion row-start"
            v-for="(direccion, key) in data.empresa.direccionesFacturacion">

            <p><strong>{{ $t('registro.envio_facturas.titulo_2') }} {{ key + 1 }}</strong></p>

            <div class="contenedor-input type-text one-slot -wo-margin">
              <label for="">{{ $t('oferta.pais') }}*</label>
              <select :name="'pais-' + key" v-model="direccion.pais" v-validate="'required'">
                <option value="">{{ $t('registro.selecciona_pais') }}</option>
                <option v-if="!!dominios" v-for="(el, key) in dominiosArray.paises" :value="Number(el[0])">{{ el[1] }}
                </option>
              </select>
              <span class='error' v-if="clicked">{{ errors.first('pais-' + key) }}</span>
            </div>

            <div class="contenedor-input type-text one-slot -wo-margin">
              <label for="">{{ $t('registro.provincia') }}*</label>
              <input type="text" :name="'provincia-' + key" v-model="direccion.provincia" v-if="direccion.pais != 1"
                v-validate="'required'">
              <select :name="'provincia-' + key" v-model="direccion.provincia" v-validate="'required'" v-else>
                <option value="">{{ $t('registro.selecciona_provincia') }}</option>
                <option v-if="!!dominios" v-for="(el, key) in dominiosArray.provincias" :value="Number(el[0])">
                  {{ el[1] }}</option>
              </select>
              <span class='error' v-if="clicked">{{ errors.first('provincia-' + key) }}</span>
            </div>


            <div class="contenedor-input one-slot">
              <label for="">{{ $t('registro.localidad') }}*</label>

              <select :name="'localidadfacturacion' + key" v-model="direccion.localidad" v-validate="'required'"
                v-if="direccion.pais == '1'">
                <option value="">{{ $t('registro.selecciona_localidad') }}</option>
                <option v-if="!!dominios" v-for="(el, key) in localidadesfilter(direccion.provincia)"
                  :value="el.idLocalidad">
                  {{ el.descripcion }}
                </option>
              </select>


              <input type="text" :name="'localidadfacturacion' + key" v-model="direccion.localidad"
                v-validate="'required'" v-else>
              <span class='error' v-if="clicked">{{ errors.first('localidadfacturacion' + key) }}</span>
            </div>

            <div class="contenedor-input type-text one-slot">
              <label for="">{{ $t('registro.cp') }}*</label>
              <input type="number" v-validate="'required|numeric'" :name="'cp-' + key" v-model="direccion.cp">
              <span class='error' v-if="clicked">{{ errors.first('cp-' + key) }}</span>
            </div>


            <div class="contenedor-input type-text three-slot">
              <label for="">{{ $t('registro.direccion') }}*</label>
              <input type="text" v-validate="'required'" :name="'direccion-' + key" v-model="direccion.direccion">
              <span class='error' v-if="clicked">{{ errors.first('direccion-' + key) }}</span>
            </div>

            <a class="row-start add-link -erase" :style="style.colorBasic" @click="eraseDireccion(key)" v-if="key != 0">
              {{ $t('registro.eliminar') }}
            </a>


          </div>

          <div class="contenedor-botones">

            <a class="row-start add-link" :style="style.colorBasic" @click="addDireccion">
              <add-icon></add-icon>{{ $t('registro.anadir_direccion') }}
            </a>

          </div>

        </template>


        <template v-if="brand.requestPerfilSectorial">

          <h3 class="epigrafe">{{ $t('registro.perfil_sectorial') }}</h3>


          <div class="contenedor-input type-text one-slot">
            <label for="">{{ $t('registro.sector_actividad') }}*</label>
            <select name="sector" v-model="data.empresa.idSector" v-validate="'required'">
              <option value="">{{ $t('registro.selecciona_sector_actividad') }}</option>
              <option v-if="!!dominios" v-for="(el, key) in dominiosArray.sectoresActividad" :value="Number(el[0])">
                {{ el[1] }}</option>
            </select>
            <span class='error' v-if="clicked">{{ errors.first('sector') }}</span>
          </div>



          <div class="contenedor-input type-text one-slot -wo-margin">
            <label for="">{{ $t('registro.rango') }}*</label>
            <select name="categoria-empresa" v-model="data.empresa.idRangoFacturacion" v-validate="'required'">
              <option value="">{{ $t('registro.selecciona_sector_actividad') }}</option>
              <option v-if="!!dominios" v-for="(el, key) in dominios.ragosFacturacion" :value="Number(key)">{{ el }}
              </option>
            </select>
            <span class='error' v-if="clicked">{{ errors.first('categoria-empresa') }}</span>
          </div>

          <div class="contenedor-input type-text one-slot -wo-margin">
            <label for="">{{ $t('registro.numero_empleados') }}*</label>
            <select name="categoria-empresa" v-model="data.empresa.idNumeroEmpleados" v-validate="'required'">
              <option value="">{{ $t('registro.selecciona_numero_empleados') }}</option>
              <option v-if="!!dominios" v-for="(el, key) in dominios.numeroDeEmpleados" :value="Number(key)">{{ el }}
              </option>
            </select>
            <span class='error' v-if="clicked">{{ errors.first('categoria-empresa') }}</span>
          </div>

          <div class="contenedor-input fecha type-text one-slot -wo-margin">
            <label for="">{{ $t('registro.anyo_fundacion') }}*</label>
            <datepicker v-model="data.empresa.anioFundacionFake" :language="(lang == 'es') ? es : ca"
              :full-month-name="true" v-validate="'required'" name="anyofundacion" :monday-first="true" :format="'yyyy'"
              :minimum-view="'year'" :disabledDates="disabledDates"></datepicker>
            <span class='error' v-if="clicked">{{ errors.first('anyofundacion') }}</span>
          </div>


          <div class="contenedor-input three-slot" v-if="brand.infoRGDP">
            <input type="checkbox" name="politica" id="politica" v-validate="'required'">
            <label for="politica">{{ $t('registro.politica_1') }}<a :href="footerLinks['Política de privacidad']"
                target="_blank">{{ $t('registro.politica_2') }}</a></label>
            <span class='error' v-if="clicked">{{ errors.first('politica') }}</span>
          </div>



        </template>



      </template>

      <div class="contenedor-botones">
        <span @click="validar">
          <template v-if="paso == 1">
            <arrow-link class="arrow-link" :text="$t('registro.solicitar_cuenta')" v-if="!boton_siguiente"
              :to="''"></arrow-link>
            <arrow-link class="arrow-link" :text="$t('registro.seguir_empresa')" v-if="boton_siguiente"
              :to="''"></arrow-link>
          </template>

          <template v-if="paso == 2">
            <arrow-link class="arrow-link" :text="$t('registro.registrar_empresa')" :to="''"></arrow-link>

          </template>
        </span>
      </div>

      <div class="tabla-rgpd" v-if="brand.infoRGDP && paso == 2">
        <h2>Protección de datos</h2>

        <div>
          <h3>Responsable del tratamiento</h3>
          <p>FUNDACION GENERAL DE LA UNIVERSIDAD DE VALLADOLID (informacion@funge.uva.es). Delegado de Protección de
            Datos: dpo@funge.uva.es</p>
        </div>

        <div>
          <h3>Finalidad principal</h3>
          <p>Las actividades de empleo y orientación laboral de la FUNGE desarrolla acciones que tienen como
            objetivo facilitar la inserción laboral de los estudiantes y titulados universitarios, para lo cual
            trata datos de carácter personal.</p>
        </div>

        <div>
          <h3>Legitimación</h3>
          <p>Relación contractual. Consentimiento del interesado. Interés público.</p>
        </div>

        <div>
          <h3>Categorías de datos personales</h3>
          <p>Datos identificativos.Datos académicos y profesionales.</p>
        </div>

        <div>
          <h3>Destinatarios</h3>
          <ul>
            <li>Empresas acogidas a los programas de prácticas.</li>
            <li>Universidad de Valladolid</li>
            <li>Entidades responsables de la selección, por cuenta de las empresas acogidas a los programas de
              prácticas.</li>
          </ul>
        </div>

        <div>
          <h3>Derechos</h3>
          <p>Acceder, rectificar y suprimir los datos, así como otros derechos, como se explica en la información
            adicional.</p>
        </div>

        <div>
          <h3>Información adicional</h3>
          <p><a target="_blank"
              href="https://funge.uva.es/proteccion-de-datos/registro-de-actividades-de-tratamiento/tratamiento-t11-empleo-y-orientacion/">Registro
              de actividades de tratamiento</a> y en nuestra <a href="https://funge.uva.es/proteccion-de-datos/"
              target="_blank">política de privacidad</a>.</p>
        </div>

      </div>

    </form>

    <image-uploader @setImg="setImage" @close="editimg = false" v-if="editimg"></image-uploader>

  </section>

</template>

<script lang="js">

import encabezado from '@/components/parts/encabezado';

import arrowLink from '@/components/parts/icons/arrow-link'

import { mapGetters, mapActions } from 'vuex';

import toggle from '@/components/parts/form/toggle'

import uploadIcon from '@/components/parts/icons/upload'

import popupInfo from '@/components/parts/popup-info';

import imageUploader from '@/components/parts/image-uploader';

import addIcon from '@/components/parts/icons/add'

import Vue from 'vue';
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import predictivo from '@/components/parts/form/predictivo';

import Datepicker from 'vuejs-datepicker';

import { es } from 'vuejs-datepicker/dist/locale'

import axios from 'axios'
import VueAxios from 'vue-axios'

import { Validator } from 'vee-validate';

Validator.extend('checkiban', {
  validate: value => {
    //TRATAMIENTO DE LA CADENA
    value = value.toUpperCase();
    value = value.trim();
    value = value.replace(/\s/g, "");

    var n1, n2;
    var ibanaux;

    n1 = getnumIBAN(value.substring(0, 1));
    n2 = getnumIBAN(value.substring(1, 2));

    ibanaux = String(n1) + String(n2) + value.substring(2);
    ibanaux = ibanaux.substring(6) + ibanaux.substring(0, 6);

    var resto = modulo97(ibanaux);

    return (resto == 1);

    function getnumIBAN(letra) {
      var ls_letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      return ls_letras.search(letra) + 10;
    }

    function modulo97(iban) {
      var parts = Math.ceil(iban.length / 7);
      var remainer = "";
      for (var i = 1; i <= parts; i++) {
        remainer = String(parseFloat(remainer + iban.substr((i - 1) * 7, 7)) % 97);
      }
      return remainer;
    }

  }
});


export default {
  name: 'Registro',
  mounted() {
    this.requestDominios();

    this.thingsOfHeader();

    $(window).scroll(e => {
      this.thingsOfHeader();
    });
  },
  data() {
    return {
      boton_siguiente: false,
      ya_registrada: true,
      paso: 1,
      editimg: false,
      img: '',
      es: es,
      data: {
        empresa: {
          ficheroLogoB64ParaAltas: '',
          extension_ficheroLogo: '',
          permiteUsarElLogo: '',
          direccion: '',
          localidad: '',
          cp: '',
          provincia: '',
          pais: '',
          telefono: '',
          web: '',
          idIdiomaPreferido: '',
          iban: '',
          idTipoEmpresa: 0,
          privada: null,
          startup: null,
          firmante1: {
            nombre: "",
            apellidos: "",
            dni: "",
            cargo: "",
            email: ""
          },
          direccionesFacturacion: [
            {
              pais: '',
              provincia: '',
              localidad: '',
              direccion: '',
              cp: ''
            }
          ]
        },
        contacto: {
          tipocontacto: [],
          localidad: '',
          idLocalidad: '',
          idIdiomaPreferido: ''
        }
      },
      clicked: false,
      dominios: {
        sectores: '',
        provincias: '',
        paises: '',
        sedes: '',
        tiposEmpresa: '',
        tiposContacto: ''
      },
      dominiosArray: {
        'sedes': "",
        'provincias': "",
        'localidades': "",
        'sectoresActividad': "",
        'paises': "",
        'tiposEmpresa': "",
        'tiposContacoEmpresa': "",
        'categoriasEmpresa': "",
        'ragosFacturacion': "",
        'numeroDeEmpleados': "",
        'actividadesrofesionales': ""
      },
      disabledDates: {
        from: new Date(),
      },

    }
  },
  computed: {
    ...mapGetters({
      style: 'getStyles',
      colors: 'basicColors',
      paises: 'getPaises',
      background: 'getBackground',
      logo: 'getLogo',
      logocolor: 'getLogoColor',
      logoencabezado: 'getLogoEncabezado',
      logosize: 'getLogoSize',
      requestDireccionContacto: 'getRequestDireccionContactoEmpresa',
      requestDireccionFullContacto: 'getRequestDireccionFullContactoEmpresa',
      requestTipoEmpresa: 'getRequestTipoEmpresa',
      brand: 'getBrand',
      footerLinks: 'getFooterLinks',
      lang: 'getLanguage'
    }),
    logoselected() {
      return (!!this.logoencabezado) ? this.logoencabezado : this.logo
    },
    sectores() {
      if (this.dominiosArray.sectoresActividad) {
        return this.dominiosArray.sectoresActividad.map(([id, description]) => ({
          id: Number(id),
          description
        }));
      }
    }
  },
  methods: {
    ...mapActions(['existeCIF', 'guardaUsuarioEmpresa', 'sendDataRegistroTRAZA']),
    requestDominios: function () {
      let dominios = [
        'sedes',
        'provincias',
        'localidades',
        'sectoresActividad',
        'paises',
        'tiposEmpresa',
        'tiposContacoEmpresa',
        'categoriasEmpresa',
        'ragosFacturacion',
        'numeroDeEmpleados',
        'actividadesrofesionales',
        'idiomasDeConfiguracion'
      ]

      let gets = new Array();

      dominios.forEach(e => {
        let get = axios.get('api/Dominios/' + e + '/' + this.lang);
        gets.push(get)
      })

      axios.all(gets)
        .then(axios.spread((...responses) => {

          responses.forEach((e, key) => {
            if (e.data.status == 0) {
              this.dominios[dominios[key]] = e.data.datos
            }
          });

          let arrays = Object.entries(this.dominios);

          arrays.forEach(e => {

            this.dominiosArray[e[0]] = e[1];

            let temporal = Object.entries(this.dominiosArray[e[0]]);
            temporal.sort(function (p1, p2) {
              if (typeof p1[1] == 'string') {
                return (p1[1].normalize("NFD").replace(/[\u0300-\u036f]/g, "") < p2[1].normalize("NFD").replace(/[\u0300-\u036f]/g, "")) ? -1 : 1;
              }
            });

            if (temporal.lenght != 0) {
              this.dominiosArray[e[0]] = temporal;
            }


          })

        }));

    },
    validateField(fieldName) {
      this.$validator.validate(fieldName);
    },
    checkCIF: function () {
      if (!!this.data.empresa.cif) {
        this.existeCIF(this.data.empresa.cif).then(r => {
          if (!!r) {
            this.data.empresa.cif = r;
            this.ya_registrada = true;
          } else {
            this.boton_siguiente = true;
            this.ya_registrada = false;
          }
        }).catch(e => { });
      }
    },
    validar: function () {
      this.clicked = true;
      this.data.empresa.anioFundacion = new Date(this.data.empresa.anioFundacionFake).getFullYear();
      
      this.$validator.validateAll().then(itsOk => {
        if (itsOk) {
          this.clicked = false;
          if (this.paso == 1) {
            if (this.ya_registrada) {
              this.enviarDatos()
            } else {
              this.paso = 2;
              setTimeout(() => {
                window.scrollTo({
                  top: 0,
                  left: 0,
                  behavior: "smooth"
                });
              }, 500)

            }
          } else if (this.paso == 2) {
            this.enviarDatos()
          }
        }
        else {
          //console.log('Errores de validación:', this.errors.items);
          this.errors.items.forEach(error => {
            console.log(`Campo: ${error.field}, Error: ${error.msg}`);
          });
          if (this.data.empresa.idSector) {
            this.errors.remove('sectorEmpresa');
            this.$validator.flag('sectorEmpresa', { valid: true, validated: true });
            this.enviarDatos()
          }
        }
      })
    },
    enviarDatos: function () {
      (!!!this.data.empresa.ficheroLogoB64ParaAltas) ? this.data.empresa.permiteUsarElLogo = false : null;

      this.guardaUsuarioEmpresa(this.data).then(r => {
        if (r) {
          this.reset();
        } else {
          this.sendDataRegistroTRAZA(this.data);
        }
      }).catch(e => {
        this.sendDataRegistroTRAZA(this.data);
      });
    },
    reset: function () {
      this.paso = 1;
      this.img = "";
      this.data = {
        empresa: {
          ficheroLogoB64ParaAltas: '',
          extension_ficheroLogo: '',
          permiteUsarElLogo: false,
          direccion: '',
          localidad: '',
          cp: '',
          provincia: '',
          pais: '',
          telefono: '',
          web: '',
          privada: null,
          startup: null,
          firmante1: {
            nombre: "",
            apellidos: "",
            dni: "",
            cargo: "",
            email: ""
          }
        },
        contacto: {}
      };
      this.clicked = false;
      this.ya_registrada = false;
      this.boton_siguiente = 'Solicitar cuenta';
    },
    setImage: function (value) {
      this.data.empresa.ficheroLogoB64ParaAltas = value.img.replace('data:image/png;base64,', '');
      this.data.empresa.extension_ficheroLogo = value.extension;
      this.img = value.img;
    },
    addDireccion() {
      let model = {
        pais: '',
        provincia: '',
        localidad: '',
        direccion: '',
        cp: ''
      };

      this.data.empresa.direccionesFacturacion.push(model);
    },
    eraseDireccion(pos) {
      this.data.empresa.direccionesFacturacion.splice(pos, 1);
    },
    thingsOfHeader: function () {
      let distance = $(window).scrollTop();
      let when = ($(window).width() > 768) ? 70 : 70;
      (distance >= when) ? $(".header").addClass('min') : $(".header").removeClass('min');
    },
    localidadesfilter(idProvincia) {
      let localidades;

      if (!!this.dominios.localidades) {
        localidades = this.dominios.localidades.filter(l => l.idProvincia == idProvincia);
        localidades = localidades.sort(function (p1, p2) {
          return (p1.descripcion < p2.descripcion) ? -1 : 1;
        });
      }
      return localidades
    },
    setProvincia() {
      if (this.values.idPais != 1) {
        this.values.provincia = '';
      }
    }
  },
  components: {
    'encabezado': encabezado,
    'arrow-link': arrowLink,
    'add-icon': addIcon,
    'toggle': toggle,
    'upload-icon': uploadIcon,
    'popup-info': popupInfo,
    'image-uploader': imageUploader,
    'predictivo': predictivo,
    Datepicker,
  },
  watch: {
    'lang'() {
      this.requestDominios();
    },
    'data.empresa.permiteUsarElLogo'() {
      if (!this.data.empresa.permiteUsarElLogo) {
        this.data.empresa.ficheroLogoB64ParaAltas = '';
        this.img = "";
        this.data.empresa.extension_ficheroLogo = '';
      }
    }
  }

}
</script>

<style scoped lang="scss">
@import "@/assets/css/colors.scss";

.header-wrapper.-fake {
  pointer-events: none;
}

.contenedor-subida-imagen {
  width: 100%;
  margin-bottom: 40px;
  position: relative;
  margin-left: 30px;

  .contenedor-imagen {
    margin-right: 40px;
  }

  .contenedor-autorizar-uso {
    position: relative;
    text-align: left;
    padding-right: 30px;
    width: auto;
    display: inline-block;

    .popup-info {
      right: 0;
    }
  }

}

.registro {
  margin-bottom: 50px;
}


.contenedor-textos {
  width: calc(100% - 270px);
  padding-left: 0;
}

.contenedor-textos .title-dato {
  height: 30px;
}

.contenedor-textos p {
  height: 20px;
}

.contenedor-textos p:empty {
  display: inline-block;
}

.contenedor-textos p:last-of-type {
  margin-bottom: 0;
}


.back {
  margin-top: 20px;
  font-size: 12px;
}

.back+.text-container {
  margin-top: 30px;
}

.text-container {
  margin: 50px auto;
  width: 100%;

  &.-firmante {
    margin-top: 0;
  }
}

.contenedor-botones {
  width: 100%;
}

.contenedor-input {
  margin-right: 0;
}

.contenedor-input.-radios {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
}

.radio-container {
  width: auto;
  display: inline-block;
  margin-right: 20px;

  &:last-of-type {
    margin-right: 0;
  }
}

.add-link {
  margin-bottom: 30px;
}


.-erase {
  margin-left: 30px;
}

.tabla-rgpd {
  padding-left: 30px;
}


@media screen and (max-width: 900px) {
  .contenedor-input {
    margin-right: 0 !important;
  }

  .text-container {
    margin: 25px 0;
  }

  .contenedor-botones {
    padding-left: 0;
  }

  .contenedor-subida-imagen {
    margin-left: 0;

    .contenedor-imagen {
      margin-right: 0;
    }
  }

}

@media screen and (max-width: 550px) {


  .contenedor-texto {
    display: none;
  }

  .contenedor-imagen {
    margin-bottom: 20px;
  }

  .tabla-rgpd {
    padding-left: 0px;
  }


}
</style>


// WEBPACK FOOTER //
// src/components/views/login/registro.vue